import React from "react";
import NormalInput from "component/common/NormalInput/index";

import styles from "./ViewProfile.module.scss";

const ViewProfile = ({ editProfileTab, changePasswordTab, data }) => {
  return (
    <div className="row">
      <div className="col-md-12 mb-4">
        <NormalInput
          label="Name"
          value={data.name}
          disabled={true}
          color="#1A203D"
        />
      </div>
      <div className="col-md-12 mb-4">
        <NormalInput
          label="Phone Number"
          value={data.phoneNumber}
          disabled={true}
          color="#1A203D"
        />
      </div>
      <div className="col-md-12 mb-4">
        <NormalInput
          label="Email ID"
          value={data.emailId}
          disabled={true}
          color="#1A203D"
        />
      </div>
      <div className="col-md-12">
        <div className={styles.profile_btn}>
          <button className={styles.edit_btn} onClick={() => editProfileTab()}>
            EDIT
          </button>
          <button
            className={styles.password_btn}
            onClick={() => changePasswordTab()}
          >
            CHANGE PASSWORD
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewProfile;
